<script setup lang="ts">


const props = defineProps(["backgroundColor", "icon"])


</script>

<template>
    
    <div class="status-bar-container"
    :style="{backgroundColor: props.backgroundColor, borderColor: props.backgroundColor}"
    
    
    >
        <img v-if="props.icon === 'tick'" src="../../assets/icons/tick-green.png" alt="ikon">
        <img v-if="props.icon === 'x'" src="../../assets/icons/close-red.png" alt="ikon">
        <slot></slot>
    </div>

</template>

<style scoped>

.status-bar-container{
    display: flex;
    align-items: center;
    padding: 1.6rem;
    border-radius: 1.6rem;
    color: var(--task-text-main);
    font-family: var(--gidole);
    font-size: 1.5rem;
    line-height: 150%;
    border-width: 1px;
    border-radius: 1rem;
    border-style: solid;
    width: 85%;
    margin: 0 auto;
    color: white;
    mix-blend-mode: multiply;
    margin-bottom: 2rem;
}

.status-bar-container img{
    width: 2.4rem;
    height: 2.4rem;
    margin-right: 1.6rem;
}

@media screen and (max-width: 850px){

    .status-bar-container{
        width: 100%;
    }

}


</style>